module.exports = __webpack_public_path__ + "media/styles/images/png/checkbox-checked-gray-4d9b55d3b3832542e2d568b2dc74c3a6.png";